import type { ResolveFn } from '../types.js';

const makeBig = (target: 6 | 8): ResolveFn => (b, roll) => {
  if (roll.total === target) return { betId: b.id, outcome: 'win', payout: b.amount };
  if (roll.total === 7) return { betId: b.id, outcome: 'lose', payout: 0 };
  return { betId: b.id, outcome: 'continue', payout: 0 };
};

export const resolveBigSix = makeBig(6);
export const resolveBigEight = makeBig(8);
